<template>
  <SystemAnnouncementStack />
  <div class="flex flex-col min-h-screen">
    <Header />
    <main class="flex flex-col grow">
      <div class="container py-8">
        <slot />
      </div>
    </main>
    <Footer />
  </div>
</template>
<script setup>
import Header from './components/main/Header.vue'
import Footer from './components/main/Footer.vue'

import SystemAnnouncementStack from '@/components/system-announcements/SystemAnnouncementStack.vue'

</script>
<style>
@import "@clubs/wusa-theme/theme.css";
@import "@/entrypoints/application.css"
</style>
